import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'ngx-owl-carousel-o';

import { HomeComponent } from './home.component';
import { WhatIsHappendComponent } from './what-is-happend/what-is-happend.component';
import { SharedModule } from '../shared/shared.module';
import { HomeRoutingModule } from './home-routing.module';
import { WhyShouldIRegisterComponent } from './why-should-iregister/why-should-iregister.component';
import { WhatWeDoComponent } from './what-we-do/what-we-do.component';
import { ViewCardComponent } from './view-card/view-card.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    HomeRoutingModule,
    CarouselModule
  ],
  declarations: [
    HomeComponent,
    WhatIsHappendComponent,
    WhyShouldIRegisterComponent,
    WhatWeDoComponent,
    ViewCardComponent
  ]
})
export class HomeModule { }
